// extracted by mini-css-extract-plugin
export var attachment = "_mm-a";
export var emailContainer = "_mm-4";
export var emailContentPaddedContainer = "_mm-b";
export var emailHeader = "_mm-6";
export var emailIframe = "_mm-3";
export var emailInfoIcon = "_mm-9";
export var emailShortenedSummary = "_mm-e";
export var infoDropdown = "_mm-0";
export var infoRowBoundedContent = "_mm-d";
export var internal = "_mm-5";
export var merchant = "_mm-8";
export var messageInputContainer = "_mm-h";
export var normal = "_mm-7";
export var replyCard = "_mm-f";
export var subtleButton = "_mm-1";
export var subtleButtonIconContainer = "_mm-2";
export var toggleViewRepliesButton = "_mm-c";
export var wrappingText = "_mm-g";